module.exports = __webpack_public_path__ + "static/media/Icona-9.213f970c.svg";